const APP_CONFIG = {
  version: "7.87.0",
  title: "Claire V7.87.0",
  version_client: "7.87.0",
};

export default APP_CONFIG;
